module.exports = __webpack_public_path__ + "static/process-detail-c.2903732a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-details/process-detail-c.svg
// module id = 1496
// module chunks = 214286880276331